import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import { basicURL } from "../../apiManager/APIConfig";

export default function PublicProfilePage() {
  const { id } = useParams();
  const [showOpenBanner, setShowOpenBanner] = useState(false);
  const [storeLinks, setStoreLinks] = useState({ ios: "", android: "" });

  const platform = useMemo(() => {
    if (typeof navigator === "undefined") return "other";
    const ua = navigator.userAgent || "";
    if (/iPad|iPhone|iPod/i.test(ua)) return "ios";
    if (/Android/i.test(ua)) return "android";
    return "other";
  }, []);
  const isMobileDevice = platform === "ios" || platform === "android";
  const appDeepLink = id ? `microlab://profile/${encodeURIComponent(id)}` : "";
  const installUrl =
    platform === "ios"
      ? storeLinks.ios || storeLinks.android
      : platform === "android"
        ? storeLinks.android || storeLinks.ios
        : "";

  useEffect(() => {
    if (!isMobileDevice) return undefined;
    let mounted = true;
    fetch(`${basicURL}public/public`, { method: "GET", headers: { Accept: "application/json" } })
      .then((res) => res.json())
      .then((data) => {
        if (!mounted) return;
        const list = Array.isArray(data?.data) ? data.data : [];
        const getByKey = (key) => {
          const raw = list.find((item) => item?.key === key)?.data;
          return typeof raw === "string" ? raw.trim() : "";
        };
        setStoreLinks({
          ios: getByKey("appstore_link"),
          android: getByKey("googleplay_link"),
        });
      })
      .catch(() => {});
    return () => {
      mounted = false;
    };
  }, [isMobileDevice]);

  useEffect(() => {
    if (!isMobileDevice || !appDeepLink) return undefined;
    let leftPage = false;
    const onPageHide = () => {
      leftPage = true;
      setShowOpenBanner(false);
    };
    window.addEventListener("pagehide", onPageHide);
    try {
      window.location.assign(appDeepLink);
    } catch (_) {}
    const timer = setTimeout(() => {
      if (!leftPage) setShowOpenBanner(true);
    }, 1200);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("pagehide", onPageHide);
    };
  }, [isMobileDevice, appDeepLink]);

  const openApp = () => {
    if (!appDeepLink) return;
    try {
      window.location.assign(appDeepLink);
    } catch (_) {}
    if (installUrl) {
      setTimeout(() => {
        try {
          window.location.assign(installUrl);
        } catch (_) {}
      }, 1400);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
        background: "#0b1220",
      }}
    >
      <Card sx={{ maxWidth: 420, width: "100%", p: 3, borderRadius: 3, textAlign: "center" }}>
        <Typography variant="h5" fontWeight={700} mb={1}>
          Microlab profile
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={2}>
          Open this profile in the Microlab app.
        </Typography>
        {(showOpenBanner || !isMobileDevice) && (
          <Button variant="contained" onClick={openApp}>
            Open in Microlab
          </Button>
        )}
      </Card>
    </Box>
  );
}
